import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushOpacityIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 9
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			stroke: "none",
			d: "M12 3a9 9 0 0 1 0 18z",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 3v18",
			opacity: .5
		})
	]
});
export default SvgBrushOpacityIcon;
